import AuthActionTypes from './AuthActionTypes'

export interface Logout {
  type: AuthActionTypes.LOGOUT
}

export function logout(): Logout {
  return {
    type: AuthActionTypes.LOGOUT,
  }
}
